/* eslint-disable eqeqeq */
import { useState, useEffect, useCallback, useLayoutEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";

import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";

import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import useMediaQuery from "@mui/material/useMediaQuery";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import LastPageIcon from "@mui/icons-material/LastPage";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";
import SaveRoundedIcon from "@mui/icons-material/SaveRounded";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import CheckCircleOutlineRoundedIcon from "@mui/icons-material/CheckCircleOutlineRounded";
import SendIcon from "@mui/icons-material/Send";
import AddBoxRoundedIcon from "@mui/icons-material/AddBoxRounded";
import GridOnOutlinedIcon from "@mui/icons-material/GridOnOutlined";
import ViewTimelineOutlinedIcon from "@mui/icons-material/ViewTimelineOutlined";

import { RoDCRequest } from "../../Redux/roStore";
import WmsHead from "./processComponent/WmsHead";
import WmsFooter from "./processComponent/WmsFooter";
import WmsContent from "./processComponent/WmsContent";
import {
  CmpButton,
  CmpButtonKIcon,
  CmpButtonKWithIcon,
} from "../../Component/Common/ToolBox/ToolBox";
import {
  DCRequest_DCRequestDelete_GETROW,
  DCRequest_DCRequestSearch_GETROW,
  DCRequest_DCRequestReverse_GETROW,
} from "../../Server/ApiV2";
import {
  Set_DCRequest_HeadObject_A_DocStat,
  Set_DCRequest_HeadObject_VocNo_DocSt,
} from "./SliceDCRequest";
import {
  fRightClick,
  fLeftClick,
  GetAttributes,
  GetDCGroupSearchTyp,
  Data_Grid_Column_Head,
  Data_Grid_Detail_Column,
  vBufferObjInit,
  GetItemFullSearchArr,
  GetSearchItem,
  fItemCodeDependency,
  GridDataColumnsItemSearch_Def,
  ItemSearchData,
  GetSIDetail,
  fValidationHead_Client,
  fValidationDetail_Client,
  ErrorMsg,
  ErrorMsgDetail,
  fSaveHead,
  GetUnitArr,
  fDisplay,
  getTransItemStockUOM,
} from "./DCRequestAction";
import {
  Set_DCRequest_HeadObject,
  Set_DCRequest_HeadObject_Init,
  Set_DCRequest_HeadObject_New_Set,
  Set_DCRequest_HeadObject_A_Total_Val,
  Set_DCRequest_HeadObject_CrLimit_OSAmt,
} from "./SliceDCRequest";

import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
import {
  fAlertToast,
  GetAccountPostingDetail,
  GetLinkDocument,
  fcheck_null_undefine_replace_empty,
  GetGitterColumns,
  FShortCutKey,
  fCheck_Doc_Rights_001,
} from "../../Utility/Utilitys";
import GCSimpleSearch from "./../../Component/Common/ReuseableComponent/GCSimpleSearch";
import {
  DCRequest_DCRequestSaveDetail_GETROW,
  DCRequest_DCRequestApprove_GETROW,
} from "./../../Server/ApiV2";
import { fExecuteAPI } from "./../../Server/Apis";
import GCAudit from "./../../Component/Common/ReuseableComponent/GCAudit";

import moment from "moment";
import GCDCRequestSearch from "./processComponent/GCDCRequestSearch";
import GCWebReport from "./../../Component/Common/ReuseableComponent/GCWebReport";
import GCAccountDetail from "./../../Component/Common/ReuseableComponent/GCAccountDetail";
import GCMenuBtn from "./../../Component/Common/ReuseableComponent/GCMenuBtn";
import GCLinkDocument from "./../../Component/Common/ReuseableComponent/GCLinkDocument";
import GCTitleSticky from "../../Component/Common/ReuseableComponent/GCTitleSticky";
import GCAuditTblCard from "../../Component/Common/ReuseableComponent/GCAuditTblCard";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import GCHead from "./processComponent/GCHead";
import GCContent from "./processComponent/GCContent";
import { DetailTblCard } from "./processComponent/DetailTblCard";
import GCNAV from "../../Component/Common/ReuseableComponent/GCNAV";

export default function DCRequest() {
  const dispatch = useDispatch();
  const [sShowMore, setShowMore] = useState(false); // nav bar arrow input value
  const [sRigntClick, setRigntClick] = useState(false); // nav bar arrow input value
  
  const vMediaQuery = useMediaQuery("(max-width:450px)");

  const vRdxWmsHead = useSelector(
    (state) => state.SliceDCRequest.value.HeadObject
  );

  const [sBufferObj, setBufferObj] = useState({
    B_SrNo: 0,
    B_ItmCd: "",
    ItmName: "",
    B_Stk_Days: 0,
    B_Sfty_Days: 0,
    B_Max_Days: 0,
    B_LD_Days: 0,
    B_Cnsm: 0,
    B_Stock: 0,
    B_BalQty: 0,
    B_Stock_DC: 0,
    B_ROP: 0,
    B_ROQ: 0,
    B_Req_Qty: 0,
    B_PU_Unit: "",
    B_PU_UnitName: "",
    B_PU_PackQty: 0,
    B_PU_Consm: 0,
    B_PU_Stock: 0,
    B_PU_ROP: 0,
    B_PU_ROQ: 0,
    B_Priority: "",
    B_Projection: 0,
    B_DC_RSP_Final: 0,
    B_RSP: 0,
    B_GP: 0,
    B_GPPerc: 0,
    B_PU_REQ_Qty: 0,
    RbtPerc: 0,
    RbtAmt: 0,
    CNPerc: 0,
    CNAmt: 0,
    Res1Amt: 0,
    Res2Amt: 0,
    Res3Amt: 0,
    Res4Amt: 0,
    Res5Amt: 0,
    B_DC_RSP: 0,
  });

  const [Grid_Detail_Rows, set_Grid_Detail_Rows] = useState([]);
  const [sDocumentTypeData, setDocumentTypeData] = useState([]);
  const [sLoactionData, setLoactionData] = useState([]);
  const [sDCLoactionData, setDCLoactionData] = useState([]);
  const [sObjRights, setObjRights] = useState({
    RNew: "Y",
    RSave: "Y",
    RDelete: "Y",
    RApprove: "Y",
    RPrint: "Y",
    RReverse: "Y",
    RClone: "Y",
  });

  const [sObjectRights, setObjectRights] = useState({
    DocTyp: "",
    Save: "Y",
    Edit: "Y",
    Del: "Y",
    View: "Y",
    Appr: "Y",
    Reverse: "Y",
    Cancel: "Y",
    Print: "Y",
    Clone: "Y",
    Lvl: "",
  });
  const [sTransItemStockObj, setTransItemStockObj] = useState({
    RPStock: 0,
    MSP: 0,
    CostPr: 0,
    LPRate: 0,
  });
  const [sNavDocValue, setNavDocValue] = useState(1); // nav bar arrow input value
  const [sUser_Doc_Arr, setUser_Doc_Arr] = useState([]);

  const fDocumentType = (e) => {
    var vSelectedObj = sDocumentTypeData?.find((obj, index) => {
      return obj.VocTyp === e;
    });
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        A_VocTyp: e,
        A_VocTypName: vSelectedObj.VocName,
      })
    );
  };

  const fDocumentNo = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        A_VocNo: e,
      })
    );
  };

  const fDocumentDate = (event) => {
    if (
      event == "Invalid Date" ||
      event == null ||
      event === undefined ||
      event === ""
    ) {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_VocDt: "",
        })
      );
    } else {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_VocDt: event,
        })
      );
    }
  };

  const fLocation = (e) => {
    let iCurrObj = sLoactionData.find((obj) => {
      return e?.target?.value === obj?.Cd;
    });
    if (!!iCurrObj && Object?.keys(iCurrObj).length > 0) {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_Loc: iCurrObj?.Cd,
          LocName: iCurrObj?.Name1,
          WHLoc: iCurrObj?.Stores,
          A_CrLimit: !!iCurrObj?.OsDetail?.CrLimit
            ? iCurrObj?.OsDetail?.CrLimit
            : 0,
          A_OsAmt: !!iCurrObj?.OsDetail?.OSAmt ? iCurrObj?.OsDetail?.OSAmt : 0,
        })
      );
    }
  };
  const fCrLimitAmt = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        A_CrLimit: e,
      })
    );
  };
  const fOsAmt = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        A_OsAmt: e,
      })
    );
  };
  const fMainGroup = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        MainGrpName: e,
        A_SubGrp: "",
        SubGrpName: "",
        A_Grp: "",
        GrpName: "",
      })
    );
  };
  const fSubGroup = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        SubGrpName: e,
        A_Grp: "",
        GrpName: "",
      })
    );
  };
  const fGroup = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        GrpName: e,
      })
    );
  };
  const fBrand = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        BrandName: e,
      })
    );
  };
  const fConsumption = (e) => {
    console.log(e);
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        A_CNSM_Type: e,
        A_CNSM_From: new Date(),
        A_CNSM_To: new Date(),
      })
    );
  };
  const fCNSM_From_DT = (event) => {
    if (
      event == "Invalid Date" ||
      event == null ||
      event === undefined ||
      event === ""
    ) {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_CNSM_From: "",
        })
      );
    } else {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_CNSM_From: event,
        })
      );
    }
  };
  const fCNSM_To_Dt = (event) => {
    if (
      event == "Invalid Date" ||
      event == null ||
      event === undefined ||
      event === ""
    ) {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_CNSM_To: "",
        })
      );
    } else {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_CNSM_To: event,
        })
      );
    }
  };
  const fLeadDays = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        A_LeadDays: e,
      })
    );
  };
  const fDCLoaction = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        A_DCLoc: e,
      })
    );
  };
  const fPromoCode = (e) => {
    dispatch(
      Set_DCRequest_HeadObject({
        ...vRdxWmsHead,
        PrmCd: e,
      })
    );
  };

  const fGC_Search_Modal = async (
    xvalue,
    xtitle,
    xSearchTyp = "Y",
    xPrnt = "",
    xLvl = "",
    xCd = "",
    xName = ""
  ) => {
    setGCSimpleSearch_Title(xtitle);

    let vExactSearchValue = await GetDCGroupSearchTyp(
      xvalue,
      xtitle,
      xSearchTyp,
      xPrnt,
      xLvl,
      xCd,
      xName
    );
    let xCdRep =
      !!vExactSearchValue && vExactSearchValue?.length > 0
        ? vExactSearchValue[0].Cd
        : "";
    let xName1Resp =
      !!vExactSearchValue && vExactSearchValue?.length > 0
        ? vExactSearchValue[0].Name1
        : "";
    if (!!vExactSearchValue && vExactSearchValue?.length > 0) {
      if (xtitle === "MainGroup") {
        dispatch(
          Set_DCRequest_HeadObject({
            ...vRdxWmsHead,
            A_MainGrp: xCdRep,
            MainGrpName: xName1Resp,
          })
        );
      } else if (xtitle === "SubGroup") {
        dispatch(
          Set_DCRequest_HeadObject({
            ...vRdxWmsHead,
            A_SubGrp: xCdRep,
            SubGrpName: xName1Resp,
          })
        );
      } else if (xtitle === "Group") {
        dispatch(
          Set_DCRequest_HeadObject({
            ...vRdxWmsHead,
            A_Grp: xCdRep,
            GrpName: xName1Resp,
          })
        );
      } else if (xtitle === "Brand") {
        dispatch(
          Set_DCRequest_HeadObject({
            ...vRdxWmsHead,
            A_Brand:
              !!vExactSearchValue && vExactSearchValue?.length > 0
                ? vExactSearchValue[0].UID
                : "",
            BrandName: xName1Resp,
          })
        );
      }
    } else {
      setGCSimpleSearchObj((obj) => ({
        ...obj,
        AnyData: xvalue,
      }));
      await GetDCGroupSearchTyp(
        xvalue,
        xtitle,
        "N",
        xPrnt,
        xLvl,
        xCd,
        xName,
        set_DataGrid_GCSimpleSearch_Row
      );
      fGCSimpleSearch_Open();
    }
  };

  //Detail Start

  const handleSelectionChange = (params) => {
    // set_Grid_Detail_Rows((prevRows) =>
    //   prevRows.map((prevRow) =>
    //     params.includes(prevRow.B_SrNo)
    //       ? { ...prevRow, Selected: "Y" }
    //       : { ...prevRow, Selected: "N" }
    //   )
    // );
    let modifiedSelect = Grid_Detail_Rows.map((el) => {
      if (params.includes(el.B_SrNo)) {
        return { ...el, Selected: "Y" };
      } else {
        return { ...el, Selected: "N" };
      }
    });
    set_Grid_Detail_Rows(modifiedSelect);
  };

  const fGrid_RowClick_Detail = async (item) => {
    setBufferObj((obj) => ({
      ...obj,
      B_SrNo: item.row.B_SrNo,
      B_ItmCd: item.row.B_ItmCd,
      ItmName: item.row.ItmName,
      B_Stk_Days: item.row.B_Stk_Days,
      B_Sfty_Days: item.row.B_Sfty_Days,
      B_Max_Days: item.row.B_Max_Days,
      B_LD_Days: item.row.B_LD_Days,
      B_Cnsm: item.row.B_Cnsm,
      B_Stock: item.row.B_Stock,
      B_BalQty: item.row.B_BalQty,
      B_Stock_DC: item.row.B_Stock_DC,
      B_ROP: item.row.B_ROP,
      B_ROQ: item.row.B_ROQ,
      B_Req_Qty: item.row.B_Req_Qty,
      B_PU_Unit: item.row.B_PU_Unit,
      B_PU_UnitName: item.row.B_PU_UnitName,
      B_PU_PackQty: item.row.B_PU_PackQty,
      B_PU_Consm: item.row.B_PU_Consm,
      B_PU_Stock: item.row.B_PU_Stock,
      B_PU_ROP: item.row.B_PU_ROP,
      B_PU_ROQ: item.row.B_PU_ROQ,
      B_Priority: item.row.B_Priority,
      B_Projection: item.row.B_Projection,
      B_DC_RSP_Final: item.row.B_DC_RSP_Final,
      B_RSP: item.row.B_RSP,
      B_GP: item.row.B_GP,
      B_GPPerc: item.row.B_GPPerc,
      B_PU_REQ_Qty: item.row.B_PU_REQ_Qty,
      RbtPerc: item.row.RbtPerc,
      RbtAmt: item.row.RbtAmt,
      CNPerc: item.row.RbtPerc,
      CNAmt: item.row.CNAmt,
      Res1Amt: item.row.Res1Amt,
      Res2Amt: item.row.Res2Amt,
      Res3Amt: item.row.Res3Amt,
      Res4Amt: item.row.Res4Amt,
      Res5Amt: item.row.Res5Amt,
      B_DC_RSP: item.row.B_DC_RSP,
    }));

    await GetUnitArr(item.row.B_ItmCd, setUnit);
  };

  const fUnit = (e) => {
    let vUnitvalue = sUnit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    setBufferObj((obj) => ({
      ...obj,
      B_PU_Unit: vUnitvalue?.Unit,
      B_PU_UnitName: vUnitvalue?.Name1,
      B_PackQty: vUnitvalue?.PackQty,
      Packing: vUnitvalue?.PackDesc,
    }));
  };

  //Item start
  const [GridDataColumnsItemSearch, setGridDataColumnsItemSearch] = useState(
    GridDataColumnsItemSearch_Def
  );
  //Item Dropdowm
  const [sUnit, setUnit] = useState([]);
  const [sItemToggleDropdown, setItemToggleDropdown] = useState(false);
  const [sItemSearchDropdownObj, setItemSearchDropdownObj] = useState({
    Type: "Any",
    Data: "",
  });

  const fOnChangeItem = (e) => {
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      [e.target.name]: e.target.value,
    }));
  };

  const fOnKeyUpItem = async (e) => {
    if (e.key == "Enter" || e._reactName == "onClick") {
      // SEARCHITEM001_GETROW
      GetSearchItem(
        sItemSearchDropdownObj.Data,
        sItemSearchDropdownObj.Type,
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }
    if (e.key == "ArrowDown" || e.keyCode == 40) {
      setTimeout(() => {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength !== 0) {
          let tabel = document.getElementById(
            "table-main-grid-dropdown-Toggle"
          );
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            ?.firstChild?.focus();
        }
      }, 100);
    }
  };

  const handleClick = useCallback(() => {
    if (sItemToggleDropdown) {
      setItemToggleDropdown(false);
      setGridSelectRowData([]);
      setItemSearchDropdownObj({
        Type: "Any",
        Data: "",
      });
    } else {
      setItemToggleDropdown(true);
      setTimeout(() => {
        document.getElementsByName("Data")[0]?.focus();
      }, 100);
    }
  }, [sItemToggleDropdown]);

  const fItemToggleClick = (e) => {
    setGridSelectRowData([]);
    setItemSearchDropdownObj((obj) => ({
      ...obj,
      Data: sBufferObj.ItmName,
    }));

    if (sBufferObj.ItmName != "") {
      GetSearchItem(
        sBufferObj.ItmName,
        "Any",
        vRdxWmsHead.A_Loc,
        setGridSelectRowData
      );
    }

    handleClick();
  };

  //ItemSearch
  const fItemSearchKey = async (e) => {
    if (e.key === "Enter" || e._reactName === "onClick") {
      let vItemSearchFull = await GetItemFullSearchArr(
        sBufferObj.ItmName,
        vRdxWmsHead.A_Loc
      );

      if (vItemSearchFull.length > 0) {
        fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      } else {
        fItemToggleClick(e);
      }
    } else if (e.key === "Backspace") {
      setBufferObj((obj) => ({
        ...obj,
        B_ItmCd: "",
        ItmName: e.target.value,
        B_Stk_Days: 0,
        B_Sfty_Days: 0,
        B_Max_Days: 0,
        B_LD_Days: 0,
        B_Cnsm: 0,
        B_Stock_DC: 0,
        B_ROP: 0,
        B_ROQ: 0,
        B_Req_Qty: 0,
        B_PU_Unit: "",
        B_PU_UnitName: "",
        B_PU_PackQty: 0,
        B_PU_Consm: 0,
        B_PU_Stock: 0,
        B_PU_ROP: 0,
        B_PU_ROQ: 0,
        B_Priority: "",
        B_Projection: 0,
        B_DC_RSP: 0,
        B_RSP: 0,
        B_GP: 0,
        B_GPPerc: 0,
        Res1Amt: 0,
        Res2Amt: 0,
        Res3Amt: 0,
        Res4Amt: 0,
        Res5Amt: 0,
        RbtPerc: 0,
        RbtAmt: 0,
        CNPerc: 0,
        CNAmt: 0,
      }));
      setUnit([]);
    }
  };

  //Modal ItemSearch
  const [sGridSelectRowData, setGridSelectRowData] = useState([]);

  //GCItemSearch
  const fGCToggleItemOnRowClick = async (e) => {
    let vItemSearchFull = await GetItemFullSearchArr(
      e.row.ItmCd,
      vRdxWmsHead.A_Loc
    );
    if (vItemSearchFull.length > 0) {
      fItemCodeDependency(vItemSearchFull, setBufferObj, setUnit);
      document.getElementsByName("B_PU_REQ_Qty")[0]?.focus();
    } else {
      // document.getElementsByName("ItmName")[0]?.focus();
    }
    setItemToggleDropdown(false);
  };

  //GCItemSearch
  const fGCToggleItemOnCellKeyDown = async (newSelectionModel, e) => {
    if (e.key === "Enter") {
      fGCToggleItemOnRowClick(newSelectionModel);
    }
  };

  // CLICK ANY WHERE AND CLOSE IF TOGGLE IS CLOSED
  useEffect(() => {
    const handleClick = (event) => {
      if (sItemToggleDropdown) {
        const toggleElement = event.target.closest(".toggleSearch");
        if (!toggleElement) {
          setItemToggleDropdown(false);
        }
      }
    };
    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, [sItemToggleDropdown]);
  //esc keyZ close item dropdown
  const escFunction = useCallback((event) => {
    if (event.key === "Escape") {
      setItemToggleDropdown(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", escFunction, false);

    return () => {
      document.removeEventListener("keydown", escFunction, false);
    };
  }, [escFunction]);
  //Item End
  //Detail end

  //GCSimpleSearch start
  //MODAL HEAD
  const [sGCSimpleSearchModal, setGCSimpleSearchModal] = useState(false);
  const [sGCSimpleSearch_Title, setGCSimpleSearch_Title] = useState("Modal");
  const [sDataGrid_GCSimpleSearch_Row, set_DataGrid_GCSimpleSearch_Row] =
    useState([]);
  const [sDataGrid_GCSimpleSearch_Column, set_DataGrid_GCSimpleSearch_Column] =
    useState([
      { field: "id", headerName: "id", hide: true, width: 90 },
      { field: "Cd", headerName: "Code", hide: false, width: 90 },
      { field: "Name1", headerName: "Name", hide: false, width: 290 },
    ]);

  const [sGCSimpleSearchObj, setGCSimpleSearchObj] = useState({
    AnyData: "",
    Name: "",
    Code: "",
  });

  const fGCSimpleSearch_Open = () => {
    setTimeout(() => {
      document.getElementById("GCSimpleSearch")?.focus();
    }, 100);
    setGCSimpleSearchModal(true);
  };

  //GCSimpleSearch

  const fGCSimpleSearch_Enter = async (e) => {
    if (sGCSimpleSearch_Title === "MainGroup") {
      await GetDCGroupSearchTyp(
        sGCSimpleSearchObj.AnyData,
        sGCSimpleSearch_Title,
        "N",
        "",
        "",
        sGCSimpleSearchObj.Name,
        sGCSimpleSearchObj.Code,
        set_DataGrid_GCSimpleSearch_Row
      );
      console.log("MainGroup");
    } else if (sGCSimpleSearch_Title === "SubGroup") {
      await GetDCGroupSearchTyp(
        sGCSimpleSearchObj.AnyData,
        sGCSimpleSearch_Title,
        "N",
        vRdxWmsHead.A_MainGrp,
        "",
        sGCSimpleSearchObj.Name,
        sGCSimpleSearchObj.Code,
        set_DataGrid_GCSimpleSearch_Row
      );
      console.log("SubGroup");
    } else if (sGCSimpleSearch_Title === "Group") {
      await GetDCGroupSearchTyp(
        sGCSimpleSearchObj.AnyData,
        sGCSimpleSearch_Title,
        "N",
        vRdxWmsHead.A_SubGrp,
        "",
        sGCSimpleSearchObj.Name,
        sGCSimpleSearchObj.Code,
        set_DataGrid_GCSimpleSearch_Row
      );
      console.log("Group");
    } else if (sGCSimpleSearch_Title === "Brand") {
      await GetDCGroupSearchTyp(
        sGCSimpleSearchObj.AnyData,
        sGCSimpleSearch_Title,
        "N",
        "",
        "",
        sGCSimpleSearchObj.Name,
        sGCSimpleSearchObj.Code,
        set_DataGrid_GCSimpleSearch_Row
      );
      console.log("Brand");
    }
  };

  const fGCSimpleSearch_RowClick = async (e) => {
    if (sGCSimpleSearch_Title === "MainGroup") {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_MainGrp: e?.row?.Cd,
          MainGrpName: e?.row?.Name1,
        })
      );
    } else if (sGCSimpleSearch_Title === "SubGroup") {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_SubGrp: e?.row?.Cd,
          SubGrpName: e?.row?.Name1,
        })
      );
    } else if (sGCSimpleSearch_Title === "Group") {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_Grp: e?.row?.Cd,
          GrpName: e?.row?.Name1,
        })
      );
    } else if (sGCSimpleSearch_Title === "Brand") {
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_Brand: e?.row?.UID,
          BrandName: e?.row?.Name1,
        })
      );
    }
    setGCSimpleSearchModal(false);
  };

  const [sErrorMsg, setErrorMsg] = useState(ErrorMsg);
  const [sErrorMsgDetail, setErrorMsgDetail] = useState(ErrorMsgDetail);

  const fClearErrorMsg = () => {
    setErrorMsg(ErrorMsg);
    setErrorMsgDetail(ErrorMsgDetail);
  };
  const fNew = async () => {
    fClearErrorMsg();
    if (sBufferObj.ItmName == "") {
      fNewHead();
      fNewDetail(0, sDocumentTypeData[0]?.VocTyp);
      document.getElementsByName("A_VocDt")[0]?.focus();
    } else {
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fNewHead = async () => {
    dispatch(Set_DCRequest_HeadObject_Init()); // Head Clearing
    // Setting Initial List Box 0th Object
    let iOsAmt = 0;
    let iCrLimitAmt = 0;
    if (Object.keys(sLoactionData[0]?.OsDetail).length > 0) {
      iOsAmt = sLoactionData[0]?.OsDetail?.OSAmt;
      iCrLimitAmt = sLoactionData[0]?.OsDetail?.CrLimit;
    }

    dispatch(
      Set_DCRequest_HeadObject_New_Set({
        A_VocTyp: sDocumentTypeData[0]?.VocTyp,
        A_VocName: sDocumentTypeData[0]?.VocName,
        A_Loc: sLoactionData[0]?.Cd,
        LocName: sLoactionData[0]?.Name1,
        WHLoc: sLoactionData[0]?.Stores,
        A_DCLoc: sDCLoactionData[0]?.UId,
        DCLocName: sDCLoactionData[0]?.UId,
        A_CrLimit: iCrLimitAmt,
        A_OsAmt: iOsAmt,
      })
    );

    setNavDocValue(1); // nav init 1
    set_Grid_Detail_Rows([]);
    setBufferObj(vBufferObjInit);
  };

  const fNewDetail = (xVocNo, xVocTyp) => {
    setBufferObj(vBufferObjInit);
    setUnit([]);
    fLoad_Grid(xVocNo, xVocTyp);
    document.getElementsByName("ItmName")[0]?.focus();
  };

  let timeout = null;
  const fSave = (xSaveType) => {
    fClearErrorMsg();
    clearTimeout(timeout);
    timeout = setTimeout(async () => {
      if (vRdxWmsHead.A_DocStat == "POST" || vRdxWmsHead.A_DocStat == "DRAFT") {
        confirmAlert({
          title: "Reverse",
          message: `Are you sure to Reverse.`,
          buttons: [
            {
              className: "alertBtn",
              label: "Yes",
              onClick: async () => {
                let reverseResp = await GetRevereTransaction();
                if (reverseResp.status == 200) {
                  fClearErrorMsg();
                  dispatch(
                    Set_DCRequest_HeadObject_A_DocStat({
                      A_DocStat: "ENTER",
                    })
                  );

                  fAlertToast("SUCCESS", "SUCCESSFULLY REVERSED");
                }
              },
            },
            {
              className: "alertBtn",
              label: "No",
              onClick: () => {},
            },
          ],
        });
      } else if (vRdxWmsHead.A_DocStat != "ENTER") {
        fAlertToast(
          "FAILED",
          "Not allowed in " + vRdxWmsHead.A_DocStat.toLowerCase() + " mode"
        );
        return;
      } else {
        let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);
        if (!validation && vMediaQuery) {
          fSummary();
        }
        if (!validation) return;
        if (xSaveType === "MainSave") {
          let validationDetil = fValidationDetail_Client(
            sBufferObj,
            setErrorMsgDetail
          );
          if (!validation && vMediaQuery) {
            fSummary();
          }
          if (!validationDetil) return;
        }

        fSaveHead(
          true,
          dispatch,
          fLoad_Grid,
          setUser_Doc_Arr,
          fNewDetail,
          sBufferObj,
          xSaveType
        );
      }
    }, 800);
  };

  //Modal

  //API REVERSETRANSACTION_GETROW
  const GetRevereTransaction = async () => {
    let vRevereTransactionObj = {
      trnTyp: sTrnTyp,
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      userCd: vRdxuserInfo.UserID,
      // revNarr: sRevNarr,
    };
    const vRevereTransaction = DCRequest_DCRequestReverse_GETROW(
      vRevereTransactionObj
    );
    return vRevereTransaction;
  };

  const fRelease_Load = () => {
    fSave("Release_Load");
  };

  const fDetailSave = async () => {
    let iDetail = Grid_Detail_Rows.filter((obj) => obj.Selected === "Y");
    if (iDetail?.length === 0) {
      fAlertToast("FAILED", "Atleast one array should be selected");
      return;
    }
    let iSaveDetail = {
      v_C_VocTyp: vRdxWmsHead.A_VocTyp,
      v_C_VocNo: vRdxWmsHead.A_VocNo,
      Details: iDetail,
      BulkSave: true,
      Loc: vRdxWmsHead.A_Loc,
    };
    let iDetailSave = await DCRequest_DCRequestSaveDetail_GETROW(iSaveDetail);
    console.log(iDetailSave);
    if (iDetailSave?.status == 200) {
      fLoad_Grid(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
      fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
    }
  };

  const fP_Value = (xPValue) => {
    let modifiedSelect = Grid_Detail_Rows.map((el) => {
      if (el.B_Priority === xPValue) {
        return { ...el, Selected: "Y" };
      } else {
        return { ...el, Selected: "N" };
      }
    });
    set_Grid_Detail_Rows(modifiedSelect);
    fTotValue(modifiedSelect);
  };

  const fSelectAll = (xPValue) => {
    if (xPValue === "Y" || xPValue === "N") {
      let modifiedSelect = Grid_Detail_Rows.map((el) => {
        return { ...el, Selected: xPValue };
      });
      set_Grid_Detail_Rows(modifiedSelect);
      fTotValue(modifiedSelect);
    } else {
      let iDetail = Grid_Detail_Rows.find((obj) => obj.Selected === "Y");
      let modifiedSelect = Grid_Detail_Rows.map((el) => {
        return { ...el, Selected: iDetail ? "N" : "Y" };
      });

      set_Grid_Detail_Rows(modifiedSelect);
      fTotValue(modifiedSelect);
    }
  };
  const fTotValue = (xGrid) => {
    let iGrid = xGrid.filter((obj) => obj.Selected === "Y");
    let iQty = 0,
      iValue = 0,
      iTotValue = 0;
    for (let i of iGrid) {
      iQty = i.B_PU_REQ_Qty;
      iValue = i.B_DC_RSP;
      iTotValue = iTotValue + iQty * iValue;
    }
    dispatch(
      Set_DCRequest_HeadObject_A_Total_Val({
        A_Total_Val: iTotValue.toFixed(4),
      })
    );
  };

  const fLoad_Grid = async (xB_VocNo, xVocTyp) => {
    let iGrid = await GetSIDetail(xB_VocNo, xVocTyp, set_Grid_Detail_Rows);

    fTotValue(iGrid);
  };

  const fMove_First = () => {
    fClearErrorMsg();
    fDisplay(
      sUser_Doc_Arr[0].VocTyp,
      sUser_Doc_Arr[0].VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(1);
  };

  const fMove_Previouse = () => {
    fClearErrorMsg();
    if (sNavDocValue > 1) {
      var row = sNavDocValue - 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].VocTyp,
        sUser_Doc_Arr[row - 1].VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };
  const fMove_Next = () => {
    fClearErrorMsg();

    if (sNavDocValue < sUser_Doc_Arr.length) {
      var row = sNavDocValue + 1;
      fDisplay(
        sUser_Doc_Arr[row - 1].VocTyp,
        sUser_Doc_Arr[row - 1].VocNo,
        dispatch,
        fNewDetail
      );
      setNavDocValue(row);
    }
  };

  const fMove_Last = () => {
    fClearErrorMsg();
    fDisplay(
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].VocTyp,
      sUser_Doc_Arr[sUser_Doc_Arr.length - 1].VocNo,
      dispatch,
      fNewDetail
    );
    setNavDocValue(sUser_Doc_Arr.length);
  };
  const vRdxuserInfo = useSelector((state) => state.login.value);
  //DELETESIDETAIL_GETROW
  const fDeleteDetail = async (SrNo=sBufferObj.B_SrNo) => {
    let vDeleteSIDetailObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      srNo:SrNo,
      userCd: vRdxuserInfo.UserID,
    };

    let FinalObj = fcheck_null_undefine_replace_empty(vDeleteSIDetailObj);
    const vDeleteSIDetail = await DCRequest_DCRequestDelete_GETROW(FinalObj);

    if (vDeleteSIDetail?.status === 200) {
      if (SrNo === 0) {
        dispatch(
          Set_DCRequest_HeadObject_A_DocStat({
            A_DocStat: "DELETE",
          })
        );
      }
      // fNewDetail(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
      fDisplay(vRdxWmsHead.A_VocTyp, vRdxWmsHead.A_VocNo, dispatch, fNewDetail);
      fAlertToast("SUCCESS", "Successfully Deleted Line Item");
    }
  };

  const fDelete = (Srno= sBufferObj.B_SrNo) => {
    if (vRdxWmsHead.A_DocStat == "POST") {
      fAlertToast("FAILED", "You are not allowed to delete in post status");
      return;
    }
    if (vRdxWmsHead.A_DocStat == "ENTER") {
      confirmAlert({
        title: "Delete",
        message: "Are you want to delete.",
        buttons: [
          {
            className: "alertBtn",
            name: "DeletYes",
            label: "Yes",
            onClick: () => {
              fDeleteDetail(Srno);
            },
          },
          {
            className: "alertBtn",
            label: "No",
            onClick: () => "",
          },
        ],
      });
      setTimeout(() => {
        document.getElementsByName("DeletYes")[0]?.focus();
      }, 100);
    }
  };
  const fApprove = async (xDocStatus) => {
    if (sBufferObj.B_ItmCd != "") {
      fAlertToast("FAILED", "Please save current line item before approve");
      return;
    }

    if (Grid_Detail_Rows.length == 0) {
      fAlertToast("FAILED", "Add atleast one line item");
      return;
    }
    let validation = fValidationHead_Client(vRdxWmsHead, setErrorMsg);
    if (!validation && vMediaQuery) {
      fSummary();
    }
    if (!validation) return;
    let iApproveObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      locCd: vRdxWmsHead.A_Loc,
      netAmt: vRdxWmsHead.A_Total_Val,
      userCd: vRdxuserInfo.UserID,
      docStatus: xDocStatus,
    };
    let iApprove = await DCRequest_DCRequestApprove_GETROW(iApproveObj);
    if (iApprove?.status == 200) {
      dispatch(
        Set_DCRequest_HeadObject_VocNo_DocSt({
          A_VocNo: vRdxWmsHead.A_VocNo,
          A_DocStat: xDocStatus,
        })
      );
      fDisplay(vRdxWmsHead.A_VocTyp, vRdxWmsHead.A_VocNo, dispatch, fNewDetail);

      fAlertToast("SUCCESS", "Successfully posted");
    }
  };

  const fOnLoad = async () => {
    let iAttributeResp = await GetAttributes(
      setDocumentTypeData,
      setLoactionData,
      setDCLoactionData,
      setObjectRights,
      setUser_Doc_Arr
    );
    if (
      Object.keys(iAttributeResp).length !== 0 &&
      vRdxWmsHead.A_VocTyp == ""
    ) {
      console.log(iAttributeResp);
      let iOsAmt = 0;
      let iCrLimitAmt = 0;
      if (Object.keys(iAttributeResp?.LocationList[0]?.OsDetail).length > 0) {
        iOsAmt = iAttributeResp?.LocationList[0]?.OsDetail?.OSAmt;
        iCrLimitAmt = iAttributeResp?.LocationList[0]?.OsDetail?.CrLimit;
      }
      dispatch(
        Set_DCRequest_HeadObject({
          ...vRdxWmsHead,
          A_VocTyp: iAttributeResp?.DocTypes[0]?.VocTyp,
          A_VocName: iAttributeResp?.DocTypes[0]?.VocName,
          A_Loc: iAttributeResp?.LocationList[0]?.Cd,
          LocName: iAttributeResp?.LocationList[0]?.Name1,
          WHLoc: iAttributeResp?.LocationList[0]?.Stores,
          A_DCLoc: iAttributeResp?.DCloc[0]?.UId,
          DCLocName: iAttributeResp?.DCloc[0]?.UId,
          A_CrLimit: iOsAmt,
          A_OsAmt: iCrLimitAmt,
        })
      );
    }

    fLoad_Grid(vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp);
  };
  //GCSimpleSearch end
  //Modal Summary START
  const [sSummaryModal, setSummaryModal] = useState(false);
  const fSummary = () => {
    setSummaryModal(true);
  };

  const fCloseSummaryModal = (e) => {
    setSummaryModal(false);
  };
  //Modal Summary END

  //Modal View end
  const [sViewModal, setViewModal] = useState(false);
  const fView = () => {
    setViewModal(true);
  };

  const fCloseViewModal = (e) => {
    setViewModal(false);
  };
  //Modal View end

  //Modal Audit start
  const sTrnTyp = "DCREQT";
  const [xAuditId, setAuditId] = useState("All");
  const [sAuditModal, setAuditModal] = useState(false);
  const [sAuditSelectArr, setAuditSelectArr] = useState([]);
  const [sGridDataAuditRows, setGridDataAuditRows] = useState([]);
  const [GridDataAuditColumns, setGridDataAuditColumns] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    {
      field: "User",
      headerName: "User Name",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Date",
      headerName: "Date",
      width: 100,
      headerClassName: "grid-header-row",
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    {
      field: "Time",
      headerName: "Time",
      width: 100,
      headerClassName: "grid-header-row",
    },
    {
      field: "IP Address",
      headerName: "IP Address",
      width: 130,
      headerClassName: "grid-header-row",
    },
    {
      field: "Old Value",
      headerName: "Old Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "New Value",
      headerName: "New Value",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmCd",
      headerName: "Item Code",
      width: 150,
      headerClassName: "grid-header-row",
    },
    {
      field: "ItmName",
      headerName: "Item Name",
      width: 250,
      headerClassName: "grid-header-row",
    },
  ]);
  const fOpenAuditModal = () => {
    setAuditModal(true);
  };
  const fAudit = async (e) => {
    let auditResp = await GetAuditField();
    if (!!auditResp) {
      setAuditId(auditResp[0]?.id);
      GetTransAudit(auditResp[0]?.id);
    }
    fOpenAuditModal();
  };

  //API AUDITFIELD_GETROW
  const GetAuditField = async () => {
    // http://localhost:3999/RpDesign/auditFields?trnTyp=WMINV08
    const vAuditField = await fExecuteAPI("AUDITFIELD_GETROW", sTrnTyp);
    if (vAuditField?.Type?.toUpperCase() === "SUCCESS") {
      setAuditSelectArr(vAuditField.ResultSet);
      return vAuditField.ResultSet;
    } else {
      fAlertToast("FAILED", vAuditField.Message);
      return vAuditField.ResultSet;
    }
  };

  //API TRANSAUDIT_GETROW
  const GetTransAudit = async (xid) => {
    let vTransAuditObj = {
      vocTyp: vRdxWmsHead.A_VocTyp,
      vocNo: vRdxWmsHead.A_VocNo,
      trnTyp: sTrnTyp,
      field: xid,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(vTransAuditObj);
    const vTransAudit = await fExecuteAPI("TRANSAUDIT_GETROW", FinalObj);
    if (vTransAudit?.Type?.toUpperCase() === "SUCCESS") {
      let vTransAuditRes = vTransAudit.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setGridDataAuditRows(vTransAuditRes);
    } else {
      fAlertToast("FAILED", vTransAudit.Message);
    }
  };
  //Modal Audit end

  //accountDetail start
  const [sAccountDetailModal, setAccountDetailModal] = useState(false);
  const [sGridDataAccountDetailRows, setGridDataAccountDetailRows] = useState(
    []
  );
  const [sGridDataAccountDetailColumns, setGridDataAccountDetailColumns] =
    useState([
      {
        field: "id",
        headerName: "Sr.No",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcCd",
        headerName: "AcCd",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "AcName",
        headerName: "AcName",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "Br",
        headerName: "Br",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "BrName",
        headerName: "BrName",
        width: 130,
        headerClassName: "grid-header-row",
      },

      {
        field: "AmtLc",
        headerName: "AmtLc",
        width: 130,
        headerClassName: "grid-header-row",
      },
      {
        field: "DrCr",
        headerName: "DrCr",
        width: 100,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr",
        headerName: "Narr",
        width: 200,
        headerClassName: "grid-header-row",
      },
      {
        field: "Narr1",
        headerName: "Narr1",
        width: 200,
        headerClassName: "grid-header-row",
      },
    ]);
  const fOpenAccountDetailModal = () => {
    setAccountDetailModal(true);
  };
  const fAccountDetail = async (e) => {
    const { HeadObject } = RoDCRequest();
    await GetAccountPostingDetail(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      setGridDataAccountDetailRows
    );

    fOpenAccountDetailModal();
  };
  const fCloseAccountDetailModal = (e) => {
    setAccountDetailModal(false);
  };
  //accountDetail end

  //fLinkDocument start
  const [sLinkDocumentModal, setLinkDocumentModal] = useState(false);
  const [sGridDataLinkDocumentRows, setGridDataLinkDocumentRows] = useState([]);
  const [sGridDataLinkDocumentColumns, setGridDataLinkDocumentColumns] =
    useState([
      {
        field: "A_VocTyp",
        headerName: "Doc.Type",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "VocName",
        headerName: "Doc.Name",
        hide: false,
        width: 180,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_VocNo",
        headerName: "Doc.No",
        hide: false,
        width: 80,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "A_DocStat",
        headerName: "Status",
        hide: false,
        width: 50,
        align: "left",
        headerAlign: "left",
      },
      {
        field: "id",
        headerName: "id",
        hide: false,
        width: 40,
        align: "left",
        headerAlign: "left",
      },
    ]);
  const fOpenLinkDocumentModal = () => {
    setLinkDocumentModal(true);
  };
  const fLinkDocument = async (e) => {
    const { HeadObject } = RoDCRequest();
    await GetLinkDocument(
      HeadObject.A_VocTyp,
      HeadObject.A_VocNo,
      sTrnTyp,
      setGridDataLinkDocumentRows
    );

    fOpenLinkDocumentModal();
  };
  const fCloseLinkDocumentModal = (e) => {
    setLinkDocumentModal(false);
  };
  //LinkDocument end

  //MODAL SEARCH
  const sEnterKeyObj = {
    key: "Enter",
  };
  const [sGridSearchHeadRowData, setGridSearchHeadRowData] = useState([]);
  const sStatusArr = ["ENTER", "POST", "DELETE", "DRAFT"];

  const [sGridDataColumnsSearch, setsGridDataColumnsSearch] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "VocName", headerName: "Doc.Name", width: 250 },
    { field: "A_VocNo", headerName: "Doc.No", width: 150 },
    {
      field: "A_VocDt",
      headerName: "Date",
      width: 200,
      valueFormatter: ({ value }) => moment(value).format("DD/MM/YYYY"),
    },
    { field: "LocName", headerName: "Location", width: 130 },
    { field: "MainGrpName", headerName: "MainGrpName", width: 90 },
    { field: "SubGrpName", headerName: "SubGrpName", width: 150 },
    { field: "GrpName", headerName: "GrpName", width: 90 },
    { field: "BrandName", headerName: "BrandName", width: 90 },
    { field: "A_LeadDays", headerName: "LeadDays", width: 90 },
  ]);
  const [sSearchModalObj, setSearchModalObj] = useState({
    Status: sStatusArr[0],
    VocNo: "",
    PostDt: "",
    Loc: sLoactionData[0]?.Cd ? sLoactionData[0]?.Cd : "",
  });

  const [sSearchModal, setSearchModal] = useState(false);
  const fSearch = async () => {
    setSearchModal(true);
    // SALESGROUPSSEARCH_GETROW -search salegroup dropdown
    document.getElementById("IdSearch")?.blur();
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: sLoactionData[0]?.Cd,
      Status: sStatusArr[0],
    }));
    GetSearchValue("", "APICallLocModal", sLoactionData[0]?.Cd);
  };

  const fCloseSearchModal = (e) => {
    setSearchModal(false);
    fClearSearchModal();
  };

  const fClearSearchModal = (e) => {
    setSearchModalObj({
      Status: "ENTER",
      VocNo: "",
      PostDt: "",
      Loc: sLoactionData[0]?.Cd,
      RefNo: "",
    });
    setGridSearchHeadRowData([]);
  };

  //GCSearch
  const fTrans_Search_Grid_RowClick = (e) => {
    fDisplay(e?.row?.A_VocTyp, e?.row?.A_VocNo, dispatch, fNewDetail);
    fCloseSearchModal();
  };

  const fonChangeStatusModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((value, index) => {
      return value == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Status: vSelectedValue,
    }));

    GetSearchValue("", "APICALLSTATUS", vSelectedValue);
  };

  const fonChangeVocNoModal = (event) => {
    setSearchModalObj((obj) => ({
      ...obj,
      VocNo: event.target.value,
    }));
  };

  const fOnChangeDateModel = (event) => {
    if (
      event?.$d == "Invalid Date" ||
      event?.$d == null ||
      event?.$d === undefined ||
      event?.$d === ""
    ) {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: "",
      }));
    } else {
      setSearchModalObj((obj) => ({
        ...obj,
        PostDt: event?.$d,
      }));
    }

    let changedDate = event?.$d;
    if (new Date(event?.$d) >= new Date("01-01-1990")) {
      GetSearchValue("", "APICALLDATE", changedDate);
    }
  };

  const fonChangeLocModal = (event, selectArr) => {
    var vSelectedValue = selectArr?.find((obj, index) => {
      return obj.UId == event.target.value;
    });
    setSearchModalObj((obj) => ({
      ...obj,
      Loc: vSelectedValue.UId,
    }));
    GetSearchValue("", "APICallLocModal", vSelectedValue.UId);
  };

  const GetSearchValue = async (e, xAPICALL, xSTATUS) => {
    if (
      e.key === "Enter" ||
      xAPICALL === "APICALLSTATUS" ||
      xAPICALL === "APICALLDATE" ||
      xAPICALL === "APICallLocModal"
    ) {
      let iPostdt =
        xAPICALL === "APICALLDATE"
          ? moment(xSTATUS).format("MM/DD/YYYY")
          : moment(sSearchModalObj.PostDt).format("MM/DD/YYYY");
      if (
        iPostdt == "Invalid date" ||
        iPostdt == null ||
        iPostdt === undefined ||
        iPostdt === ""
      ) {
        iPostdt = "01/01/1900";
      }

      let vSearchObj = {
        status: xAPICALL === "APICALLSTATUS" ? xSTATUS : sSearchModalObj.Status,
        vocNo: sSearchModalObj.VocNo,
        vocDate: iPostdt,
        // VocDt: "01/01/1900",
        loc: xAPICALL === "APICallLocModal" ? xSTATUS : sSearchModalObj.Loc,
        v_UserCd: vRdxuserInfo.UserID,
      };
      let FinalObj = fcheck_null_undefine_replace_empty(vSearchObj);
      const vSearch = await DCRequest_DCRequestSearch_GETROW(FinalObj);

      if (vSearch?.status === 200) {
        let vSearchArr = vSearch?.data?.ResultSet.map((obj, i) => ({
          ...obj,
          id: i + 1,
          // A_VocDt: moment(obj.A_VocDt).format("DD/MM/YYYY"),
        }));
        setGridSearchHeadRowData(vSearchArr);
      } else {
        fAlertToast("FAILED", vSearch?.response?.data?.Status);
      }
    }
  };

  //PRINT

  const vRdxDBKernObj = useSelector((state) => state.SliceDB.value.DBKernObj);
  const [sWebReportModal, setWebReportModal] = useState(false);
  const [sWebReportUrlModal, setWebReportUrlModal] = useState("");
  const fWebReport = () => {
    setWebReportModal(true);
  };

  const fCloseWebReportModal = (e) => {
    setWebReportModal(false);
  };

  const fPrint = useCallback(
    (xPrnTyp) => {
    let webReport = vRdxDBKernObj?.WEB_REPORT_BASE_URL;
      //  http://192.168.50.243:8010/WebReports/WMS/LoadingList?prntyp=WMLDLSTD&VocTyp=LD001&VocNo=LDSDC00002

      let urlPrint =
        webReport?.Val +
        "WMS/DCRequest?trntyp=" +
        xPrnTyp +
        "&VocTyp=" +
        vRdxWmsHead.A_VocTyp +
        "&VocNo=" +
        vRdxWmsHead.A_VocNo;
      setWebReportUrlModal(urlPrint);
      fWebReport();
    },
    [vRdxWmsHead.A_VocNo, vRdxWmsHead.A_VocTyp, vRdxDBKernObj]
  );
  //PRINT END

  //MODAL SEARCH END
  useEffect(() => {
    fOnLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [sData_Grid_Column_Head, setData_Grid_Column_Head] = useState(
    Data_Grid_Column_Head
  );
  const [sData_Grid_Detail_Column, setData_Grid_Detail_Column] = useState(
    Data_Grid_Detail_Column
  );

  useEffect(() => {
    GetGitterColumns(
      set_DataGrid_GCSimpleSearch_Column,
      "DC_REQUEST_GCSimpleSearch",
      sDataGrid_GCSimpleSearch_Column
    );
    GetGitterColumns(
      setData_Grid_Column_Head,
      "DC_REQUEST_HEAD_GRID",
      Data_Grid_Column_Head
    );
    GetGitterColumns(
      setData_Grid_Detail_Column,
      "DC_REQUEST_DETAIL",
      Data_Grid_Detail_Column
    );
    GetGitterColumns(
      setsGridDataColumnsSearch,
      "DC_REQUEST_SEARCH",
      sGridDataColumnsSearch
    );
    GetGitterColumns(
      setGridDataAuditColumns,
      "WMS_SALES_INVOICE_AUDIT",
      GridDataAuditColumns
    );
    GetGitterColumns(
      setGridDataColumnsItemSearch,
      "LOADINGRECEIPT_ITEM_SEARCH",
      GridDataColumnsItemSearch
    );
    GetGitterColumns(
      setGridDataAccountDetailColumns,
      "ACPSTINGDTLTRNS",
      sGridDataAccountDetailColumns
    );
    GetGitterColumns(
      setGridDataLinkDocumentColumns,
      "WMINV08LINKDDOC",
      sGridDataLinkDocumentColumns
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    let iCurrObj = sLoactionData.find((obj) => {
      return vRdxWmsHead.A_Loc === obj?.Cd;
    });
    if (!!iCurrObj && Object?.keys(iCurrObj).length > 0) {
      dispatch(
        Set_DCRequest_HeadObject_CrLimit_OSAmt({
          A_OsAmt: !!iCurrObj?.OsDetail?.OSAmt ? iCurrObj?.OsDetail?.OSAmt : 0,
          A_CrLimit: !!iCurrObj?.OsDetail?.CrLimit
            ? iCurrObj?.OsDetail?.CrLimit
            : 0,
        })
      );
    }
  }, [dispatch, sLoactionData, vRdxWmsHead.A_Loc]);

  useEffect(() => {
    var resultObj = fCheck_Doc_Rights_001(
      vRdxWmsHead.A_DocStat,
      vRdxWmsHead.A_VocTyp,
      !!sObjectRights && sObjectRights.length > 0 ? sObjectRights : []
    );
    setObjRights(resultObj);
  }, [vRdxWmsHead.A_DocStat, vRdxWmsHead.A_VocTyp, sObjectRights]);
  useEffect(() => {
    if (
      vRdxWmsHead.A_DocStat !== "ENTER" ||
      vRdxWmsHead.A_Loc === null ||
      vRdxWmsHead.A_Loc === undefined ||
      vRdxWmsHead.A_Loc === "" ||
      sBufferObj.B_Itmcd === "" ||
      sBufferObj.B_Unit === ""
    ) {
      setTransItemStockObj({
        RPStock: 0,
        MSP: 0,
        CostPr: 0,
        LPRate: 0,
      });
      return;
    } else {
      getTransItemStockUOM(
        setTransItemStockObj,
        sBufferObj.B_Itmcd,
        sBufferObj.B_Unit,
        vRdxWmsHead.A_Loc
      );
    }
  }, [
    dispatch,
    sBufferObj.B_Itmcd,
    sBufferObj.B_Unit,
    vRdxWmsHead.A_Loc,
    vRdxWmsHead.A_DocStat,
  ]);
  const fkeyup2 = useCallback(
    (e) => {
      let vRdxPrint = "DCREQT";
      FShortCutKey(
        e,
        "IdNew",
        "IdSave",
        "IdApprove",
        "IdSearch",
        "IdDelete",
        "IdAudit",
        vRdxPrint,
        fPrint
      );
    },
    [fPrint]
  );
  useLayoutEffect(() => {
    window.addEventListener("keyup", fkeyup2);

    return () => {
      window.removeEventListener("keyup", fkeyup2);
    };
  }, [fkeyup2]);
  return (
    <div className="container-fluid">
      {/* mobile Screen nav  */}
            <GCNAV
              fNew={fNew}
              xDisableNew={sObjRights.RNew == "N"}
              fSave={() => {
                fSave("MainSave");
              }}
              xDisableSave={sObjRights.RSave == "N"}
              sRightClick={sRigntClick}
              xRightClick={(e) => {
                fLeftClick(e);
                setShowMore(false);
                setRigntClick(false);
                setTimeout(() => {
                  document.getElementsByName("A_VocDt")[0]?.focus();
                }, 100);
              }}
              xLeftClick={(e) => {
                fRightClick(e);
                setShowMore(false);
                setRigntClick(true);
                setTimeout(() => {
                  document.getElementsByName("B_ItmName")[0]?.focus();
                }, 100);
              }}
              setShowMore={setShowMore}
              sShowMore={sShowMore}
              fDelete={fDelete}
              xDisableDelete={
                sObjRights.RDelete == "N" ? true : false
              }
              isBtnDraft={sObjRights.RApprove == "N" && false}
              fDraft={() => {
                fApprove("DRAFT");
              }}
              xDisableDraft={
                vRdxWmsHead.A_DocStat != "ENTER" ? true : false
              }
              fApprove={() => {
                fApprove("POST");
              }}
              xDisableApprove={
                vRdxWmsHead.A_DocStat == "ENTER" ||
                vRdxWmsHead.A_DocStat == "DRAFT"
                  ? false
                  : true
              }
              fView={() => {
                fView();
              }}
              fSummary={() => {
                fSummary();
              }}
              fSearch={() => {
                fSearch();
              }}
            />
             <div style={{ paddingTop: vMediaQuery ? "50px" : "" }}>
             <div className="row" style={{ padding: "0px" }}>
          <div className="col-12" style={{ padding: "0px" }}>
          <div className="Wms-DCRequest-grv ">
            <>
              <Grid
                container
                spacing={0}
                className="my-2 Wms-inbound-grn-nav-sm-hide pb-4"
                columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
                sx={{ alignItems: "center" }}
              >
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="New"
                    xOnClick={fNew}
                    xVariant="text"
                    xDisabled={sObjRights.RNew == "N" ? true : false}
                    xSize="small"
                    xId={"IdNew"}
                    xSendIcon={<AddBoxRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Save"
                    xOnClick={() => {
                      fSave("MainSave");
                    }}
                    xVariant="text"
                    xDisabled={sObjRights.RSave == "N" ? true : false}
                    xSize="small"
                    xId={"IdSave"}
                    xSendIcon={<SaveRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  {sObjRights.RApprove == "N" && false ? (
                    <CmpButton
                      xbtnName="Draft"
                      xOnClick={() => {
                        fApprove("DRAFT");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat != "ENTER" ? true : false
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "N" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  ) : (
                    <CmpButton
                      xbtnName="Approve"
                      xOnClick={() => {
                        fApprove("POST");
                      }}
                      xVariant="text"
                      // xDisabled={sObjRights.RApprove == "N" ? true : false}
                      xDisabled={
                        vRdxWmsHead.A_DocStat == "ENTER" ||
                        vRdxWmsHead.A_DocStat == "DRAFT"
                          ? false
                          : true
                      }
                      xSize="small"
                      xId={sObjRights.RApprove == "Y" ? "IdApprove" : ""}
                      xSendIcon={<CheckCircleOutlineRoundedIcon />}
                    />
                  )}
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Search"
                    xOnClick={() => {
                      fSearch();
                    }}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId={"IdSearch"}
                    xSendIcon={<SearchRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2.5} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Delete"
                    xOnClick={() => {
                      fDelete();
                    }}
                    xVariant="text"
                    xDisabled={sObjRights.RDelete == "N" ? true : false}
                    xSize="small"
                    xId="IdDelete"
                    xSendIcon={<DeleteRoundedIcon />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={0.5} lg={0.5}>
                  <CmpButtonKIcon
                    xOnClick={fMove_First}
                    xDisabled={false}
                    xIcon={<FirstPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Previouse}
                    xDisabled={false}
                    xIcon={<ArrowBackIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={4} md={1} lg={1} className="text-center">
                  {sNavDocValue} of {sUser_Doc_Arr.length}
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Next}
                    xDisabled={false}
                    xIcon={<ArrowForwardIosIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid
                  item
                  xs={1}
                  sm={2}
                  md={0.5}
                  lg={0.5}
                  className="text-center"
                >
                  <CmpButtonKIcon
                    xOnClick={fMove_Last}
                    xDisabled={false}
                    xIcon={<LastPageIcon fontSize={"small"} />}
                  />
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <DropdownButton
                    id="dropdown-basic-button"
                    title="Print"
                    variant="outlined"
                    size="sm"
                    disabled={sObjRights.RPrint == "N" ? true : false}
                  >
                    <Dropdown.Item
                      id="PrintId"
                      onClick={(e) => {
                        fPrint("DCREQT");
                      }}
                    >
                      Detail
                    </Dropdown.Item>
                  </DropdownButton>
                </Grid>
                <Grid item xs={1} sm={2} md={1} lg={1}>
                  <CmpButton
                    xbtnName="Audit"
                    xOnClick={() => {
                      fAudit();
                    }}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xId="IdAudit"
                    xSendIcon={<SendIcon />}
                  />
                </Grid>
                {/* <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <CmpButton
                    xbtnName="Account Detail"
                    xOnClick={fAccountDetail}
                    xVariant="text"
                    xDisabled={false}
                    xSize="small"
                    xSendIcon={<AccountBalanceOutlinedIcon />}
                  />
                </Grid> */}
                <Grid item xs={1} sm={1} md={1.5} lg={1.5}>
                  <GCMenuBtn
                    menuLabel="More"
                    menuItems={[
                      { label: "Account Detail", onClick: fAccountDetail },
                      // { label: "Link Document", onClick: fLinkDocument },
                    ]}
                  />
                </Grid>
              </Grid>
              
            </>
            <>
              <div id="wms-salese-invoice-id">
                <div className=" wms-incoice-sales-m main-wms-sales-invoice-hide-sm main-wms-sales-invoice-show-sm ">
                  <GCHead
                    xErrorMsg={sErrorMsg}
                    Grid_Head_Columns={sData_Grid_Column_Head}
                    HeadObject={vRdxWmsHead}
                    sDocumentTypeData={sDocumentTypeData}
                    sLoactionData={sLoactionData}
                    sDCLoactionData={sDCLoactionData}
                    fDocumentType={fDocumentType}
                    fDocumentNo={fDocumentNo}
                    fDocumentDate={fDocumentDate}
                    fLocation={fLocation}
                    fCrLimitAmt={fCrLimitAmt}
                    fOsAmt={fOsAmt}
                    fMainGroup={fMainGroup}
                    fSubGroup={fSubGroup}
                    fGroup={fGroup}
                    fBrand={fBrand}
                    fConsumption={fConsumption}
                    fCNSM_From_DT={fCNSM_From_DT}
                    fCNSM_To_Dt={fCNSM_To_Dt}
                    fLeadDays={fLeadDays}
                    fDCLoaction={fDCLoaction}
                    fPromoCode={fPromoCode}
                    fRelease_Load={fRelease_Load}
                    fGC_Search_Modal={fGC_Search_Modal}
                  />
                </div>
                <div className="wms-sales-Content wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <div className="wms-incoice-sales-m">
                    <GCContent
                      sTransItemStockObj={sTransItemStockObj}
                      xTransItemStockShow={
                        vRdxuserInfo?.UserRights?.ViewCost?.toUpperCase() == "Y"
                      }
                      vRdxWmsHead={vRdxWmsHead}
                      xErrorMsgDetail={sErrorMsgDetail}
                      xBufferObj={sBufferObj}
                      sUnit={sUnit}
                      fUnit={fUnit}
                      fRequiredQty={(e) => {
                        setBufferObj((obj) => ({
                          ...obj,
                          B_PU_REQ_Qty: e,
                        }));
                      }}
                      //GC toggle
                      fOpenContentItemSearchModalKey={fItemSearchKey}
                      fItemName={(e) => {
                        setBufferObj((obj) => ({
                          ...obj,
                          ItmName: e.target.value,
                        }));
                      }} //onchange main input
                      xMediaQuery={vMediaQuery} //mobile screen
                      xonClickbtn={fItemSearchKey} // onclick icon open div on main screen
                      xrows={sGridSelectRowData} //Grid Row GCToggle Search from API
                      xcolumns={GridDataColumnsItemSearch} //GCToggleSearch-Grid col GCToggle Search fron Action
                      xRowCellClick={fGCToggleItemOnCellKeyDown} //GCToggleSearch-grid clic
                      xRowClick={fGCToggleItemOnRowClick} //GCToggleSearch- grid click
                      xToggle={sItemToggleDropdown} //GCToggleSearch-to show div using true/false (after xonClickbtn state value will be passed)
                      xData={ItemSearchData} // GCToggleSearch-select-tag arr
                      xOnChangeDropdownInput={fOnChangeItem} //GCToggleSearch-input search onchane DATA/TYPE
                      xDropdownObj={sItemSearchDropdownObj} // GCToggleSearch-object DATA/TYPE
                      xOnKeyUpDropdownInput={fOnKeyUpItem}
                    />
                     {vMediaQuery && (
                                          <DetailTblCard
                                            data={Grid_Detail_Rows}
                                            onClick={(item) => {
                                              fGrid_RowClick_Detail(item);
                                            }}
                                            fDelete={fDelete}
                                            xDisableDelete={
                                              sObjRights.RDelete == "N" ? true : false
                                            }
                                          />
                                        )}
                  </div>
                  <div className="wms-sales-content-grid xs-screen-hide">
                    <div style={{ height: "40vh", width: "100%" }}>
                      <DataGrid
                        rowHeight={30}
                        headerHeight={40}
                        getRowId={(row) => row?.B_SrNo}
                        getRowClassName={(params) =>
                          params.indexRelativeToCurrentPage % 2 === 0
                            ? "mui-even-row"
                            : "mui-odd-row"
                        }
                        sx={{
                          border: 1,
                          borderColor: "primary.light",
                        }}
                        rows={Grid_Detail_Rows}
                        columns={sData_Grid_Detail_Column}
                        hideFooter={Grid_Detail_Rows?.length < 100}
                        checkboxSelection={Grid_Detail_Rows.some(
                          (row) => row?.Flg === "N"
                        )}
                        onSelectionModelChange={handleSelectionChange}
                        selectionModel={Grid_Detail_Rows.filter(
                          (row) => row?.Selected === "Y"
                        ).map((row) => row?.B_SrNo)}
                        onRowClick={fGrid_RowClick_Detail}
                        disableSelectionOnClick
                        // components={{
                        //   Toolbar: GridToolbar,
                        // }}
                      />
                    </div>
                  </div>
                </div>
                <div className="wms-sales-footer wms-incoice-sales-m main-wms-sales-invoice-hide-sm ">
                  <WmsFooter
                    HeadObject={vRdxWmsHead}
                    fDetailSave={fDetailSave}
                    fP_Value={fP_Value}
                    fSelectAll={fSelectAll}
                  />
                </div>
              </div>
            </>
          </div>
        </div>
      </div>
             </div>
      
      
      {/* simple search ref doc  */}
      <GCSimpleSearch
        open={sGCSimpleSearchModal}
        xCloseSearchModal={(e) => {
          setGCSimpleSearchModal(false);
          setGCSimpleSearchObj({
            AnyData: "",
            Name: "",
            Code: "",
          });
          set_DataGrid_GCSimpleSearch_Row([]);
        }}
        xTitle={sGCSimpleSearch_Title}
        xAnyData={sGCSimpleSearchObj.AnyData}
        xModelObj={sGCSimpleSearchObj}
        xSearchEnter={(e) => {
          if (e.key === "Enter") {
            fGCSimpleSearch_Enter();
          }
          if (e.key == "ArrowDown" || e.keyCode == 40) {
            var selectedLength =
              document.getElementsByClassName("Mui-selected").length;
            setTimeout(() => {
              if (selectedLength !== 0) {
                let tabel = document.getElementById("table-main-grid-5");
                tabel
                  ?.getElementsByClassName("MuiDataGrid-row")[0]
                  .firstChild?.focus();
              }
            }, 200);
          }
        }}
        xonChangeInputModal={(e) => {
          setGCSimpleSearchObj({
            ...sGCSimpleSearchObj,
            [e.target.name]: e.target.value,
          });
        }}
        xGridArr={sDataGrid_GCSimpleSearch_Row}
        xGridDataColumnsSearch={sDataGrid_GCSimpleSearch_Column}
        xRowClick={(e) => {
          fGCSimpleSearch_RowClick(e);
        }}
        xClearSimpleSearch={() => {
          setGCSimpleSearchObj({
            AnyData: "",
            Name: "",
            Code: "",
          });
          set_DataGrid_GCSimpleSearch_Row([]);
        }}
        xMediaQuery={vMediaQuery}
        xEnterObj={{
          key: "Enter",
        }}
        xClassName={"model-GCSimpleSearch2"}
      />

      {/* //View Modal  */}
      <Modal
        open={sViewModal}
        onClose={fCloseViewModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"View"} onClose={fCloseViewModal} />

          {/* <div className="d-flex justify-content-end close-icon-sm">
            <CloseIcon onClick={fCloseViewModal} />
          </div> */}
          <div className="py-2">
            <div style={{ height: "50vh", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowId={(row) => row?.B_SrNo}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={Grid_Detail_Rows}
                columns={sData_Grid_Detail_Column}
                hideFooter={Grid_Detail_Rows?.length < 100}
                checkboxSelection={Grid_Detail_Rows.some(
                  (row) => row?.Flg === "N"
                )}
                onSelectionModelChange={handleSelectionChange}
                selectionModel={Grid_Detail_Rows.filter(
                  (row) => row?.Selected === "Y"
                ).map((row) => row?.B_SrNo)}
                onRowClick={fGrid_RowClick_Detail}
                disableSelectionOnClick
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </div>
          <div className="py-2">
            <WmsFooter
              HeadObject={vRdxWmsHead}
              fDetailSave={fDetailSave}
              fP_Value={fP_Value}
              fSelectAll={fSelectAll}
            />
          </div>
        </Box>
      </Modal>
      {/* summary  */}
      <Modal
        open={sSummaryModal}
        onClose={fCloseSummaryModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="model-Variance">
          <GCTitleSticky title={"Summary"} onClose={fCloseSummaryModal} />
          {/* <div className="d-flex justify-content-end close-icon-sm">
            <CloseIcon onClick={fCloseSummaryModal} />
          </div> */}
          <div className="py-2"></div>
        </Box>
      </Modal>

      {/* Audit  */}
      {/* <GCAudit
        xOpen={sAuditModal}
        xTitle={"AUDIT"}
        fCloseAuditModal={(e) => {
          setAuditModal(false);
        }}
        sAuditSelectArr={sAuditSelectArr}
        GridDataAuditColumns={GridDataAuditColumns}
        GridDataAuditRows={sGridDataAuditRows}
        xAuditId={xAuditId}
        fonChangeAuditSelect={(e) => {
          setAuditId(e.target.value);
          GetTransAudit(e.target.value);
        }}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
      /> */}
      <GCAuditTblCard
        xOpen={sAuditModal}
        xLabel={vRdxWmsHead.A_VocTypName + " - " + vRdxWmsHead.A_VocNo}
        fCloseAuditModal={setAuditModal}
        trnTyp={sTrnTyp}
        vocTyp={vRdxWmsHead.A_VocTyp}
        vocNo={vRdxWmsHead.A_VocNo}
      />
      {/* head search  */}
      {/* Search  */}
      <GCDCRequestSearch
        open={sSearchModal}
        xStatusArr={sStatusArr}
        xLocationArr={sLoactionData}
        fonChangeStatusModal={fonChangeStatusModal}
        fonChangeVocNoModal={fonChangeVocNoModal}
        fOnChangeDateModel={fOnChangeDateModel}
        fonChangeLocModal={fonChangeLocModal}
        xGetSearchValue={GetSearchValue}
        fCloseSearchModal={fCloseSearchModal}
        fClearSearchModal={fClearSearchModal}
        GridSearchHeadRowData={sGridSearchHeadRowData}
        GridDataColumnsSearch={sGridDataColumnsSearch}
        xOnCellKeyDownSearch={(newSelectionModel, e) => {
          //GCSearch
          if (e.key === "Enter") {
            fTrans_Search_Grid_RowClick(newSelectionModel);
          }
        }}
        xOnRowClickSearch={fTrans_Search_Grid_RowClick}
        vMediaQuery={vMediaQuery}
        xEnterObj={sEnterKeyObj}
        xTitle={"DCRequest - Search"}
        xStatusVal={sSearchModalObj.Status}
        xVocNoVal={sSearchModalObj.VocNo}
        xPostDtVal={sSearchModalObj.PostDt}
        xLocVal={sSearchModalObj.Loc}
      />

      {/* print  */}
      <GCWebReport
        xfCloseWebReportModal={fCloseWebReportModal}
        xWebReportUrlModal={sWebReportUrlModal}
        xTitle="Report"
        xWebReportModal={sWebReportModal}
      />

      <GCAccountDetail
        xOpen={sAccountDetailModal}
        fCloseDetailModal={fCloseAccountDetailModal}
        GridDataAccountDetailColumns={sGridDataAccountDetailColumns}
        GridDataAccountDetailRows={sGridDataAccountDetailRows}
        xTitle={"Account Detail"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />

      <GCLinkDocument
        xOpen={sLinkDocumentModal}
        fCloseDetailModal={fCloseLinkDocumentModal}
        GridDataLinkDocumentColumns={sGridDataLinkDocumentColumns}
        GridDataLinkDocumentRows={sGridDataLinkDocumentRows}
        xTitle={"Link Document"}
        xLabelVocType={vRdxWmsHead.A_VocTyp}
        xLabelVocName={vRdxWmsHead.A_VocTypName}
        xLabelVocNo={vRdxWmsHead.A_VocNo}
      />
    </div>
  );
}
